import { render, staticRenderFns } from "./GenderPayGap.vue?vue&type=template&id=79557e46&"
import script from "./GenderPayGap.vue?vue&type=script&lang=js&"
export * from "./GenderPayGap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports